import React from 'react';
import { Link } from 'react-router-dom';
import styles from './WelcomeSection.module.css';

const WelcomeSection = () => {
    const interiorImage = "/images/21-DSC09419.jpg";

    return (
        <section className={styles.welcomeSection}>
            <div className={styles.container}>

                {/* Left Column: Image */}
                <div className={styles.imageColumn}>
                    <div className={styles.imageWrapper}>
                        <img
                            src={interiorImage}
                            alt="Berli Brewing Co. Interior"
                            className={styles.image}
                        />
                    </div>
                </div>

                {/* Right Column: Text Content */}
                <div className={styles.textColumn}>
                    <h2 className={styles.heading}>
                        WELCOME<br />TO BERLI
                    </h2>
                    <p className={styles.description}>
                        Step inside Berli Brewing Co., a place built on the belief that good things, done right, lift everyone around them. Hyperlocal ingredients, 12 craft beers brewed with quiet attention, and a space where you — and your dog — are not just welcome, but celebrated.
                    </p>

                    <Link to="/about" className={styles.aboutBtn}>
                        Discover Our Story
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default WelcomeSection;